import { FlexLayoutModule } from '@angular/flex-layout';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { LoadingSplashScreenComponent } from './loading-splash-screen.component';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
    declarations: [LoadingSplashScreenComponent],
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        FlexLayoutModule
    ],
    exports: [LoadingSplashScreenComponent]
})
export class LoadingSplashScreenModule { }
